export default __webpack_public_path__ + "1lIxiNk-logo_black.svg";